import { Grid, Typography } from "@mui/material";
import Chart, { SCALE_TYPES } from "./Chart";

interface ChartByStringProps {
  xData: Array<string>;
  yData: Array<number>;
  title?: string;
  valueFormatter?: Function;
  bars?: boolean;
}

const ChartByString = ({
  title,
  xData,
  yData,
  valueFormatter,
  bars,
}: ChartByStringProps) => {
  const dateFormatter = (value: string) => {
    return value;
  };

  return (
    <Grid
      item
      container
      direction="column"
      spacing={1}
      justifyContent={"center"}
      alignItems={"center"}
    >
      <Grid item container width={"100%"}>
        <Grid item container>
          {title && (
            <Grid item>
              <Typography variant="h4" sx={{ fontWeight: "700px !important" }}>
                {title}
              </Typography>
            </Grid>
          )}
        </Grid>
        <Grid item container direction="row">
          <Chart
            xData={xData}
            yData={yData}
            scaleType={SCALE_TYPES.BAND}
            xDataFormatter={dateFormatter}
            yDataFormatter={valueFormatter}
            bars={bars}
          />
        </Grid>
      </Grid>
    </Grid>
  );
};

export default ChartByString;
